import Color from 'color';
import styled from 'styled-components';
import type { ReportContextStanding } from './reportContextUsers';

const ink = '#1c1c1c';
const inkMuted = '#3d4450';
const goodInk = '#166534';
const goodBg = '#ecfdf3';
const goodLine = Color('#16a34a').alpha(0.35).toString();
const incidentInk = '#c2410c';
const incidentBg = '#fff7ed';
const incidentLine = Color('#ea580c').alpha(0.32).toString();
const alertInk = '#9f1239';
const alertBg = '#fff1f2';
const alertLine = Color('#e11d48').alpha(0.32).toString();
const neutralInk = '#3f4a5a';
const neutralBg = '#f3f4f6';
const neutralLine = Color('#6b7280').alpha(0.28).toString();

const standingLine = (standing: ReportContextStanding) => {
  if (standing === 'alert') return alertLine;
  if (standing === 'incident') return incidentLine;
  if (standing === 'neutral') return neutralLine;
  return goodLine;
};

const standingBg = (standing: ReportContextStanding) => {
  if (standing === 'alert') return alertBg;
  if (standing === 'incident') return incidentBg;
  if (standing === 'neutral') return neutralBg;
  return goodBg;
};

const standingInk = (standing: ReportContextStanding) => {
  if (standing === 'alert') return alertInk;
  if (standing === 'incident') return incidentInk;
  if (standing === 'neutral') return neutralInk;
  return goodInk;
};

export const Wrap = styled.div<{ $compact?: boolean }>`
  margin: ${({ $compact }) => ($compact ? '0 0 12px' : '0 0 14px')};
`;

export const Label = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${inkMuted};
  margin-bottom: 8px;
`;

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Chip = styled.div<{ $standing: ReportContextStanding }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  padding: 4px 8px 4px 4px;
  border-radius: 999px;
  border: 1px solid ${({ $standing }) => standingLine($standing)};
  background: ${({ $standing }) => standingBg($standing)};
`;

export const Name = styled.span`
  min-width: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: ${ink};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Standing = styled.span<{ $standing: ReportContextStanding }>`
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${({ $standing }) => standingInk($standing)};
`;
